/*
 Created by qing on 2020/12/29
 Des:
 */
import BaseConfig from "../BaseConfig";
import {CONFIG_TYPE__DASHBOARD} from "../type";
import instances from "../../RyDashBoard/instances";
import RyDashBoard from "../../RyDashBoard";
import context from '../../main.js'

class DashboardConfig extends BaseConfig {
  constructor() {
    super()

    this.h = 15

    this.minW = 10
    this.minH = 5

    this.pH = 7
    this.pW = 60

    this.pMinW = 10
    this.pMaxW = 60
    this.pMinH = 5
    this.pMaxH = 200

    this.appId = ''
    this.dashboardId = ''
    this.chartId = ''

    this.chartInfo = null
    this.Dashboard = RyDashBoard.init({
      userId: context.$store.getters.userId,
      companyId: context.$store.getters.currentCompanyId,
      appId: this.appId ? this.appId : context.$store.getters.currentAppId,
      dashboardId: this.dashboardId
    })
  }

  get title() {
    return this.configName || DashboardConfig._title
  }

  set title(content) {
    this.configName = content
  }

}

DashboardConfig._title = '图表'
DashboardConfig.type = CONFIG_TYPE__DASHBOARD

DashboardConfig.prototype.configType = DashboardConfig.type
DashboardConfig.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    appId: this.appId,
    dashboardId: this.dashboardId,
    chartId: this.chartId
  }
}
DashboardConfig.prototype.setConf = function (opts) {
  this.setBase(opts)
  this.appId = opts.appId
  this.dashboardId = opts.dashboardId
  this.chartId = opts.chartId

  if (opts.hasOwnProperty('pH')) this.pH = opts.pH
  if (opts.hasOwnProperty('pW')) this.pW = opts.pW
  if (opts.hasOwnProperty('pX')) this.pX = opts.pX
  if (opts.hasOwnProperty('pY')) this.pY = opts.pY
}
DashboardConfig.prototype.getValue = function () {

  context.$store.dispatch('actionDashboardLayoutView', {
    appId: this.appId,
    dashboardId: this.dashboardId
  }).then(res => {

    RyDashBoard.prototype.chartDataPreviewFun = ({chartId, currentPage, pageSize, sort, chart, filter}) => {
      return context.$store.dispatch('actionDashboardChartDataGet', {
        appId: this.appId,
        companyId: context.$store.getters.currentCompanyId,
        dashboardId: this.dashboardId,
        chartId,
        currentPage,
        pageSize,
        sort,
        filter,
        chart,
      })
    }

    this.Dashboard.setConf(res)
    const chart = res.chartList.filter(item => this.chartId === item.chartId)[0]
    if (chart) {
      const item = this.createItem(chart.chartType)
      item.setBase(chart)
      item.parent = this.Dashboard

      this.chartInfo = item
      this.chartInfo.getValue()
    }

    console.log('chartInfo', this.chartInfo)
  }).catch(console.error)

}

DashboardConfig.instancesMap = (() => {
  const obj = {}
  Object.values(instances).forEach(item => {
    obj[item.type] = item
  })
  return obj
})()

DashboardConfig.prototype.createItem = function (chartType) {
  return new DashboardConfig.instancesMap[chartType]()
}

export default DashboardConfig
